











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleFavoriteTemplateMutation_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityCardFavorite_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ToggleFavoriteTemplateSuccess",
  "abstractKey": null
};

(node ).hash = "13fa740c0512ce016feb10c0bbd0aaaf";

export default node;
